import ProgressBar from "@ramonak/react-progress-bar";
import React from "react";
import Modal from "react-modal";

// Bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement("#root"); // Make sure this matches your app's root element id

const ProgressModal = ({
  isOpen,
  progress,
  onCancel,
  title = "Your mockup is being processed.",
}) => {
  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "28rem",
      width: "100%",
      padding: "2rem",
      border: "none",
      borderRadius: "0.5rem",
      backgroundColor: "white",
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      style={customStyles}
      contentLabel="Progress Modal"
    >
      <div className="text-center">
        <h3 
          className="font-medium text-gray-900" 
          style={{ 
            fontSize: '22px', 
            marginBottom: '16px',
            lineHeight: '1.3'
          }}
        >
          {title}
        </h3>

        <div style={{ marginBottom: '20px' }}>
          <ProgressBar
            completed={progress}
            maxCompleted={100}
            bgColor="#C93312"
            baseBgColor="#e0e0e0"
            isLabelVisible={true}
            height="25px"
          />
        </div>

        <button
          onClick={onCancel}
          className="grey-btn"
          style={{ textTransform: "capitalize" }}
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
};

export default ProgressModal;
